import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'Dashboard/Threat Protection/List'

export const DATA_REQUEST_ASYNC = createAsyncTypes('DATA_REQUEST', `${typeKey}`)

export const FILTER_CHANGE = `${typeKey}/FILTER_CHANGE`
export const DATE_FILTER_CHANGE = `${typeKey}/DATE_FILTER_CHANGE`
export const SEARCH_CHANGE = `${typeKey}/SEARCH_CHANGE`
export const SEARCH_RESET = `${typeKey}/SEARCH_RESET`

export const LIST_INIT_AND_SHOW = `${typeKey}/LIST_INIT_AND_SHOW`
export const LIST_CLOSE = `${typeKey}/CLOSE`

export const CREATE_INCIDENT_ASYNC = createAsyncTypes('CREATE_INCIDENT', `${typeKey}`)
export const FETCH_INCIDENTS_CSV_ASYNC = createAsyncTypes('FETCH_INCIDENTS_CSV', `${typeKey}`)

export const PAGINATE_CHANGE = `${typeKey}/PAGINATE_CHANGE`

export const bannerTypeKey = '+btk'
